<template>
  <section>
    <v-btn
      :color="color"
      :dark="dark"
      :[size]="true"
      @click.stop="dialog = true"
    >
      <v-icon v-if="icon" class="mr-1" small>{{ icon }}</v-icon>
      {{ btnText }}
    </v-btn>

    <v-dialog v-model="dialog" max-width="400">
      <v-card>
        <v-card-title>
          <h4 class="fw text-center orange--text">
            <v-icon v-if="icon" color="orange" size="20" class="mr-1">{{
              icon
            }}</v-icon>
            {{ title }}
          </h4>
        </v-card-title>

        <v-card-text>
          <v-text-field
            v-model="name"
            label="Full name"
            dense
            prepend-icon="mdi-card-text"
            color="amber darken-2"
            :rules="rules.text"
            clearable
            outlined
            required
            v-if="!msg"
          >
          </v-text-field>
          <v-text-field
            v-model="email"
            label="Email Address"
            :rules="rules.email"
            dense
            color="amber darken-2"
            clearable
            prepend-icon="mdi-email"
            outlined
            required
            @input="checkEmail"
            :error-messages="err"
            v-if="!msg"
          >
          </v-text-field>
          <v-select
            :items="roles"
            label="User Role"
            v-model="userRole"
            autocomplete="off"
            hide-details
            color="amber darken-2"
            dense
            outlined
            class="mb-5"
            v-if="!msg"
            prepend-icon="mdi-clipboard-account-outline"
          >
          </v-select>
          <v-combobox
            v-if="role == roleType.SUPER_ADMIN && !msg"
            :items="groups"
            label="Company/Group"
            v-model="selectedGroup"
            color="amber darken-2"
            @keyup="search"
            hide-details
            outlined
            autocomplete="new-password"
            dense
            prepend-icon="mdi-account-group"
          >
          </v-combobox>
          <p v-if="msg" class="fw text-h6 text-center info--text">
            <v-progress-circular
              :rotate="360"
              :size="22"
              :width="3"
              class="caption"
              :value="(counter / timeLimit) * 100"
              color="info"
            >
              {{ counter }}
            </v-progress-circular>
            <v-icon color="info">mdi-party-popper</v-icon> {{ msg }}
          </p>
        </v-card-text>

        <v-card-actions>
          <v-spacer v-if="msg"></v-spacer>
          <v-btn color="red darken-1" outlined @click="dialog = false">
            Close
          </v-btn>
          <v-spacer v-if="!msg"></v-spacer>

          <v-btn
            required
            v-if="!msg"
            color="amber darken-2"
            :dark="valid"
            @click="sendInvite"
            :disabled="!valid"
            :loading="loading"
          >
            <v-icon class="mr-1" small>mdi-send</v-icon>
            Send
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script lang="ts">
import { Group, RoleType } from "@/types";
import { validations } from "@/utils";
import Vue from "vue";
import VueTypes from "vue-types";

export default Vue.extend({
  name: "InviteBtn",

  data() {
    return {
      dialog: false,
      loading: false,
      email: "",
      timeLimit: 5,
      counter: 1,
      name: "",
      userRole: 3,
      roleType: RoleType,
      msg: "",
      err: "",
      selectedGroup: "",
      rules: {
        text: [validations.empty],
        email: [validations.email],
      },
      roles: [
        { text: "Admin", value: 2 },
        { text: "User", value: 3 },
      ],
      groupsFilter: { limit: 10, search: { name: "" } },
    };
  },
  methods: {
    async sendInvite() {
      this.loading = true;
      const { name, email, selectedGroup, userRole } = this;
      const resp = await this.$store.dispatch("Users/sendInvite", {
        name,
        email,
        userRole,
        group: selectedGroup.value,
        groupName: selectedGroup.text,
      });
      if (resp?.success) {
        this.msg = "invitation was sent successfully!";
      } else {
        this.msg = "Something went wrong..";
      }
      this.loading = false;
      this.timer();
    },
    async checkEmail() {
      const { email } = this;
      if (validations.email(email) === true) {
        const resp = await this.$store.dispatch("Users/checkEmail", email);
        if (resp?.success) {
          this.err = "";
        } else {
          this.err = "Username/e-mail is already in use";
        }
      } else {
        this.err = "";
      }
    },
    timer() {
      const timer = setInterval(() => {
        this.counter++;
        if (this.counter > this.timeLimit) {
          this.clear();
          clearInterval(timer);
        }
      }, 1000);
    },
    clear() {
      this.dialog = false;
      this.name = "";
      this.email = "";
      this.msg = "";
      this.counter = 1;
    },
    search(e: Event) {
      const target = e.target as HTMLTextAreaElement;
      const text = target.value;
      if (text) {
        this.groupsFilter.search.name = text;
        this.fetchGroups();
      }
    },
    fetchGroups() {
      this.$store.dispatch("Users/fetchGroups", this.groupsFilter);
    },
  },
  computed: {
    valid() {
      return (
        this.name.length > 0 &&
        validations.email(this.email) === true &&
        this.err.length == 0
      );
    },
    role(): number {
      return this.$store.getters["Users/getRole"];
    },
    groups() {
      if (this.role > RoleType.SUPER_ADMIN) {
        return [];
      }
      const groups = this.$store.getters["Users/getGroups"];
      return groups.map((group: Group) => {
        return { text: group.name, value: group._id || group.id };
      });
    },
  },
  created() {
    this.fetchGroups();
  },
  props: {
    size: VueTypes.string.def("small"),
    color: VueTypes.string.def("amber darken-2"),
    icon: VueTypes.string.def("mdi-email-send"),
    btnText: VueTypes.string.def("Invite"),
    title: VueTypes.string.def("Pine3 Invitation"),
    dark: VueTypes.bool.def(true),
  },
});
</script>
